import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenavContainer, MatSidenav } from '@angular/material/sidenav';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { filter } from 'rxjs/operators';
import { Account } from 'projects/internal/r1-component-library/src/lib/components/appcloud-login/appcloud-credentials/appcloud-credentials.model';
import { GenericYesNoComponent } from 'projects/internal/r1-component-library/src/lib/components/dialogs/generic-yes-no/generic-yes-no.component';
import { AccountsStore } from '../../../../stores/accounts.store';
import { AccountsTableComponent } from './accounts-table/accounts-table.component';
import { EditAccountComponent } from './edit-account/edit-account.component';
import { ViewAccountComponent } from './view-account/view-account.component';
import { AccountsKpiComponent } from './accounts-kpi/accounts-kpi.component';
import { AccountCreationChartComponent } from './account-creation-chart/account-creation-chart.component';
import { AccountPatch } from '../../../../services/manage-accounts.service';

/**
 * "Accounts" tool page (UXPin: AppCloud Admin - 2024 › Accounts): KPI card, "New Account Creation"
 * chart, serverside paginated table and a right sidenav to view/edit one account.
 */
@Component({
    selector: 'r1-accounts-list',
    templateUrl: './accounts-list.component.html',
    styleUrls: ['./accounts-list.component.scss'],
    imports: [
        MatSidenavContainer,
        MatSidenav,
        MatButton,
        MatIconButton,
        MatIcon,
        MatDivider,
        AccountsTableComponent,
        EditAccountComponent,
        ViewAccountComponent,
        AccountsKpiComponent,
        AccountCreationChartComponent,
    ],
    providers: [AccountsStore],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountsListComponent {
    readonly store = inject(AccountsStore);
    readonly #dialog = inject(MatDialog);

    accountPatched(patch: AccountPatch & { id: number }) {
        const { id, ...rest } = patch;
        this.store.patchAccount({ id, patch: rest });
    }

    confirmDelete(account: Account) {
        this.#dialog
            .open(GenericYesNoComponent, {
                data: {
                    title: `Delete ${account.name}?`,
                    message: `Organization ${account.id} will be permanently deleted. This cannot be undone.`,
                },
            })
            .afterClosed()
            .pipe(filter(Boolean))
            .subscribe(() => this.store.deleteAccount(account.id!));
    }
}
